export function fileValidator(name, errors, message="File required") {
  if (!this[name]) {
    errors[name] = message;
  }
  return errors;
}